import React from 'react';
import {useAppDispatch} from '../../../../../../../../../app/hooks';
import {
    AppearanceTabSettingsContainer
} from '../../../../../../../../elements/appearanceTabSettingsContainer/AppearanceTabSettingsContainer';
import {selectEnablePersonalizedVehicleDescription, updateSettings} from '../../../../widgetAppearanceUpdateSlice';
import {
    CustomSwitchFieldWithTitle
} from "../../../../../../../../elements/customSwitchFieldWithTitle/CustomSwitchFieldWithTitle";

interface ComponentProps {
}

export const EnablePersonalizedVehicleDescriptionComponent: React.FC<ComponentProps> = (_) => {
    const dispatch = useAppDispatch();

    return <AppearanceTabSettingsContainer
        title="Vehicle Description"
        withSwitch={false}
    >
        <CustomSwitchFieldWithTitle
            textOnTrue={"Enabled"}
            textOnFalse={"Disabled"}
            title={"Personalized Vehicle Description"}
            description={'Once enabled, the vehicle card will have a user-personalized description based on the conversation the user has had up to that point.'}
            valueSelector={selectEnablePersonalizedVehicleDescription}
            toggleValue={(v) => dispatch(updateSettings({
                enablePersonalizedVehicleDescription: v
            }))}
        />
    </AppearanceTabSettingsContainer>
}
